import React from "react";
import { Box, Chip, Typography } from "@material-ui/core";

const colorMap = {
  default: "default",
  primary: "primary",
  secondary: "secondary",
  warning: "secondary", // fallback
};

export const FilterChips = ({
  options = [{ label: "All", value: "all" }],
  selectedValue = "all",
  clickHandler = () => {
    alert("No handler added");
  },
}) => {
  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 16 }}>
      <Typography variant="body1" style={{ fontWeight: 700, marginRight: 16 }}>
        Filter by Status:
      </Typography>

      {options.map((option) => {
        const label =
          option.label === "All"
            ? option.label
            : `${option.label} : ${option.count}`;

        return (
          <Chip
            key={option.value}
            label={label}
            clickable
            variant={selectedValue === option.value ? "default" : "outlined"}
            color={colorMap[option.color] || "default"}
            onClick={() => clickHandler(option)}
            style={{ marginRight: 8, marginBottom: 8 }}
          />
        );
      })}
    </Box>
  );
};
